import {atom} from "recoil";

import { FilterRule, FilterGroup } from "../types/filter";


export interface BaseFilterState {
    offers: BaseFilterOfferState[];
    cascades: BaseFilterCascadeState[];
}

export interface BaseFilterOfferState {
    offerId: string;
    filters: FilterRule[];
    filterGroups: FilterGroup[];
}

export interface BaseFilterCascadeState {
    cascadeId: string;
    filters: FilterRule[];
    filterGroups: FilterGroup[];
}


const loadFromLocalStorageEffect = (key: string) => ({setSelf}: {setSelf: (value: BaseFilterState) => void}) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue != null) {
        try {
            setSelf(JSON.parse(savedValue));
        } catch (error) {
            console.warn('Failed to parse filter state from localStorage:', error);
        }
    }
};

export const filterAtom = atom<BaseFilterState>({
    key: "filterAtom",
    default: {
        offers: [],
        cascades: [],
    },
    effects: [
        loadFromLocalStorageEffect('filterState'),
    ]
});

export const saveFiltersToLocalStorage = (filterState: BaseFilterState) => {
    localStorage.setItem('filterState', JSON.stringify(filterState));
};
